import React from 'react';
import { AgFinancing } from '@indigo-ag/schema';
import { LegalBody, TinyTitle } from '@indigo-ag/component-module';

import { utils } from 'shared';
import { CreditApprovalStatusTag } from './CreditApprovalStatusTag';
import i18next from 'core/i18n';

interface CreditApprovalStatusProps {
  phase2: AgFinancing['phase2'];
}

export const CreditApprovalStatus: React.FunctionComponent<CreditApprovalStatusProps> = ({ phase2 }) => {
  const updatedBy = phase2?.creditApprovalDecisionChangedBy;
  const updatedAt = phase2?.creditApprovalDecisionChangedAt;

  return (
    <>
      <div className="flex align-items-center">
        <CreditApprovalStatusTag status={phase2?.creditApprovalStatus} />
        {(updatedBy || updatedAt) && (
          <LegalBody>
            {updatedBy ? utils.UserUtil.getUserFullName(updatedBy) : null}
            {updatedBy && updatedAt ? ' - ' : null}
            {updatedAt ? utils.date.formatDate(updatedAt) : null}
          </LegalBody>
        )}
      </div>
      {phase2?.creditApprovalDecisionNotes ? (
        <div className="flex align-items-center">
          <TinyTitle className="mr-1">{i18next.t('notes')}:</TinyTitle>
          <LegalBody className="mt-0">{phase2?.creditApprovalDecisionNotes}</LegalBody>
        </div>
      ) : null}
    </>
  );
};
